/* PJE cards v4 - 2026-08-01. SIMPLIFIED ON PURPOSE.

   WHAT WAS REMOVED IN v4 AND WHY (three of Raza's reported bugs were all
   caused by things this file was doing):

   1. NAV HEART INJECTION - REMOVED. v3 injected the header wishlist heart from
      JS. It appeared on desktop where a WISHLIST text link already exists, it
      never matched the bag icon's size, and it could not carry a count badge
      styled like the bag's. The header heart + bag now live in
      sections/pje-header.liquid as REAL MARKUP, sized and styled together.
      This file only keeps them in sync (counts), it no longer creates them.
      RULE: chrome that belongs in the header belongs in the header section.

   2. MINI-BANNER SCROLL DRIVE - REMOVED. It caused the scroll lag AND the
      large empty gap under the banners on mobile: the pattern works by making
      the section TALLER than its content (height = content + hidden strip
      width) so there is scroll distance to convert into sideways movement.
      When it mis-measured, that extra height stayed visible as dead space.
      Not worth it - the strip is swipeable natively.

   3. AUTO-NAVIGATE ON ADD FAILURE - REMOVED. This is the "some products add to
      cart AND open the product page" bug. v3 called
      window.location.href='/products/'+handle when a product had no available
      variant, and again in .catch(). So made-to-order / out-of-stock pieces
      (and any add that returned an error) navigated instead of reporting.
      Now: no automatic navigation, ever. Unavailable pieces show an enquiry
      state on the button; genuine errors revert the icon and shake.

   LAYOUT (Raza's spec): heart top-RIGHT on the image, nothing else there.
   Add-to-bag on the product-name row, right of the title.

   IN-CART STATE: /cart.js is read on boot; anything already in the bag shows
   the bag button filled navy with a gold dot. Tapping an in-cart button adds
   one more (jewellery carts legitimately hold duplicates).

   RELATED TRAP (fixed in pje-mobile.css): pje-fixes.css stretches EVERY child
   of .img with !important - the heart override there must stay MORE SPECIFIC
   than (0,2,0) or the white-disc-over-photos bug returns.

   TOUCH GUARD: the whole card is one <a>; buttons block the full pointer
   sequence, not just click, or the anchor navigates before the handler runs.

   Wishlist shares the PDP's localStorage key 'pje_wishlist', record shape
   {id,handle,title,image,price,url}, matched by handle in both directions. */
(function(){
  var KEY='pje_wishlist';
  function list(){ try{ var l=JSON.parse(localStorage.getItem(KEY)||'[]'); return Array.isArray(l)?l:[]; }catch(e){ return []; } }
  function save(l){ try{ localStorage.setItem(KEY, JSON.stringify(l)); }catch(e){} document.dispatchEvent(new CustomEvent('pje:wish:changed')); }
  function handleOf(href){ var m=(href||'').match(/\/products\/([^\/?#]+)/); return m?decodeURIComponent(m[1]):null; }
  function inList(h){ return list().some(function(it){ return it && it.handle===h; }); }

  var css=''+
  '.pje-wish{position:absolute;top:8px;right:8px;z-index:20;width:34px;height:34px;border-radius:50%;border:1px solid rgba(1,0,83,.14);background:rgba(255,255,255,.95);display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;box-shadow:0 2px 10px rgba(1,0,83,.16);-webkit-tap-highlight-color:transparent;touch-action:manipulation;transition:transform .15s ease}'+
  '.pje-wish svg{width:16px;height:16px;fill:none;stroke:#010053;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round;display:block;transition:fill .18s ease,stroke .18s ease}'+
  '.pje-wish:active{transform:scale(.86)}'+
  '.pje-wish.on svg{fill:#E23744;stroke:#E23744}'+
  '.pje-wish.pop{animation:pjePop .32s ease}'+
  '@keyframes pjePop{0%{transform:scale(1)}45%{transform:scale(1.28)}100%{transform:scale(1)}}'+
  '@keyframes pjeShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}'+
  '.pje-nmrow{display:flex;align-items:flex-start;justify-content:space-between;gap:10px}'+
  '.pje-nmrow>.nm{flex:1 1 auto;min-width:0}'+
  '.pje-bag{flex:0 0 auto;position:relative;z-index:3;width:32px;height:32px;margin-top:1px;border-radius:50%;border:1px solid rgba(168,135,59,.55);background:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;-webkit-tap-highlight-color:transparent;touch-action:manipulation;transition:background .25s ease,border-color .25s ease,transform .15s ease}'+
  '.pje-bag svg{width:15px;height:15px;fill:none;stroke:#A8873B;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round;display:block;transition:stroke .25s ease}'+
  '.pje-bag:active{transform:scale(.86)}'+
  '.pje-bag.busy{pointer-events:none}'+
  '.pje-bag.busy svg{animation:pjeSpin .7s linear infinite;transform-origin:50% 50%}'+
  '@keyframes pjeSpin{to{transform:rotate(360deg)}}'+
  '.pje-bag.done{background:#0F3B2E;border-color:#0F3B2E;animation:pjePop .34s ease}'+
  '.pje-bag.done svg{stroke:#fff}'+
  '.pje-bag.incart{background:#010053;border-color:#010053}'+
  '.pje-bag.incart svg{stroke:#fff}'+
  '.pje-bag.incart::after{content:"";position:absolute;top:-3px;right:-3px;width:11px;height:11px;border-radius:50%;background:#C6A664;border:2px solid #fff;box-sizing:border-box}'+
  '.pje-bag.enq{border-color:rgba(1,0,83,.3)}'+
  '.pje-bag.enq svg{stroke:#010053}'+
  '.pje-bag.err{animation:pjeShake .3s ease}'+
  '@media(max-width:640px){.pje-wish{width:36px;height:36px;top:6px;right:6px}.pje-bag{width:34px;height:34px}.pje-bag svg{width:16px;height:16px}}';
  var st=document.createElement('style'); st.textContent=css; document.head.appendChild(st);

  var HEART='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.2S4.8 15.6 3 11.2C1.7 8 3.8 4.8 7.2 4.8c1.9 0 3.6 1 4.8 2.6 1.2-1.6 2.9-2.6 4.8-2.6 3.4 0 5.5 3.2 4.2 6.4-1.8 4.4-9 9-9 9z"/></svg>';
  var BAG='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8.8h12a1.6 1.6 0 0 1 1.6 1.8l-.9 8.2a2.4 2.4 0 0 1-2.4 2.2H7.7a2.4 2.4 0 0 1-2.4-2.2l-.9-8.2A1.6 1.6 0 0 1 6 8.8z"/><path d="M8.8 11.2V6.8a3.2 3.2 0 0 1 6.4 0v4.4"/></svg>';
  var SPIN='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4a8 8 0 1 0 8 8"/></svg>';
  var CHECK='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 8"/></svg>';
  var CHAT='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 15.2a2 2 0 0 1-2 2H8l-4 3.4V5.8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/></svg>';

  function claim(btn, fn){
    ['pointerdown','mousedown','touchstart'].forEach(function(ev){
      btn.addEventListener(ev, function(e){ e.stopPropagation(); }, {passive:true});
    });
    btn.addEventListener('touchend', function(e){ e.preventDefault(); e.stopPropagation(); fn(); }, {passive:false});
    btn.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (e.detail === 0 || !('ontouchstart' in window)) fn();
    });
  }

  /* ---- cart state ---- */
  var cartSet={};
  function paintCart(){
    document.querySelectorAll('.pje-bag[data-h]').forEach(function(b){
      if(b.classList.contains('enq')) return;
      var on=!!cartSet[b.getAttribute('data-h')];
      if(on && !b.classList.contains('done')) b.classList.add('incart');
      if(!on) b.classList.remove('incart');
      b.setAttribute('aria-label', on ? 'In bag - add one more' : 'Add to bag');
    });
  }
  function refreshCount(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      var n=String(c.item_count);
      document.querySelectorAll('[data-cart-count],.cart-count,#CartCount,.pje-cart-count,.pje-bagn').forEach(function(el){ el.textContent=n; });
      cartSet={};
      (c.items||[]).forEach(function(it){ if(it && it.handle) cartSet[it.handle]=1; });
      paintCart();
      document.dispatchEvent(new CustomEvent('pje:cart:changed',{detail:{count:c.item_count}}));
    }).catch(function(){});
  }
  function product(handle){ return fetch('/products/'+handle+'.js').then(function(r){ if(!r.ok) throw new Error('http '+r.status); return r.json(); }); }

  /* header wishlist count (markup lives in pje-header.liquid) */
  function wishCount(){
    var n=list().length;
    document.querySelectorAll('.pje-wishn').forEach(function(el){
      el.textContent=String(n);
      if(n>0) el.removeAttribute('hidden'); else el.setAttribute('hidden','');
    });
  }
  document.addEventListener('pje:wish:changed', wishCount);
  window.addEventListener('storage', function(e){
    if(e.key!==KEY) return;
    wishCount();
    document.querySelectorAll('.pje-wish').forEach(function(w){
      var c=w.closest('.pcard,.pje-pcard'); if(!c) return;
      var le=c.tagName==='A'?c:c.querySelector('a[href*="/products/"]');
      var h=handleOf(le&&le.getAttribute('href'));
      if(h) w.classList.toggle('on', inList(h));
    });
  });

  function inject(card){
    if(!card || card.dataset.pjeAct==='4') return;
    var img=card.querySelector('.img');
    var nm=card.querySelector('.nm');
    if(!img||!nm) return;
    var linkEl = card.tagName==='A' ? card : card.querySelector('a[href*="/products/"]');
    var handle = handleOf(linkEl && linkEl.getAttribute('href'));
    if(!handle) return;
    card.dataset.pjeAct='4';

    /* heart, on the image */
    var w=card.querySelector('.pje-wish');
    if(!w){
      w=document.createElement('button');
      w.type='button'; w.className='pje-wish'; w.setAttribute('aria-label','Save to wishlist'); w.innerHTML=HEART;
      if(inList(handle)) w.classList.add('on');
      claim(w, function(){
        var l=list(), i=-1;
        for(var k=0;k<l.length;k++){ if(l[k] && l[k].handle===handle){ i=k; break; } }
        if(i>-1){ l.splice(i,1); save(l); w.classList.remove('on'); return; }
        w.classList.add('on'); w.classList.remove('pop'); void w.offsetWidth; w.classList.add('pop');
        product(handle).then(function(p){
          var l2=list();
          if(!l2.some(function(it){ return it && it.handle===handle; })){
            l2.push({id:p.id,handle:p.handle,title:p.title,image:(p.featured_image||''),price:p.price,url:'/products/'+p.handle});
            save(l2);
          }
        }).catch(function(){
          var l2=list();
          if(!l2.some(function(it){ return it && it.handle===handle; })){
            var im=card.querySelector('.img img');
            l2.push({id:null,handle:handle,title:nm.textContent.trim(),image:im?im.src:'',price:null,url:'/products/'+handle});
            save(l2);
          }
        });
      });
      img.appendChild(w);
    }

    /* bag, on the name row */
    var b=card.querySelector('.pje-bag');
    if(!b){
      var row=card.querySelector('.pje-nmrow');
      if(!row){
        row=document.createElement('div'); row.className='pje-nmrow';
        nm.parentNode.insertBefore(row, nm);
        row.appendChild(nm);
      }
      b=document.createElement('button');
      b.type='button'; b.className='pje-bag'; b.innerHTML=BAG;
      row.appendChild(b);
      claim(b, function(){
        if(b.classList.contains('busy')) return;
        /* Made-to-order / sold-out: go to the product page ONLY on a second,
           deliberate tap of the enquiry icon. Never automatically. */
        if(b.classList.contains('enq')){ window.location.href='/products/'+handle; return; }
        b.classList.remove('incart','err');
        b.classList.add('busy'); b.innerHTML=SPIN;
        product(handle).then(function(p){
          var v=null;
          for(var k=0;k<p.variants.length;k++){ if(p.variants[k].available){ v=p.variants[k]; break; } }
          if(!v){
            b.classList.remove('busy'); b.classList.add('enq'); b.innerHTML=CHAT;
            b.setAttribute('aria-label','Made to order - tap to view this piece');
            b.setAttribute('title','Made to order - tap to view');
            return;
          }
          return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:v.id,quantity:1})})
            .then(function(r){ if(!r.ok) throw new Error('add '+r.status); return r.json(); })
            .then(function(){
              b.classList.remove('busy'); b.classList.add('done'); b.innerHTML=CHECK;
              cartSet[handle]=1;
              refreshCount();
              setTimeout(function(){ b.classList.remove('done'); b.innerHTML=BAG; paintCart(); },1600);
            });
        }).catch(function(){
          /* NEVER navigate here - this was the "adds to cart and also opens the
             product page" bug. Report and stay put. */
          b.classList.remove('busy'); b.innerHTML=BAG;
          b.classList.remove('err'); void b.offsetWidth; b.classList.add('err');
          b.setAttribute('aria-label','Could not add - please try again');
          paintCart();
        });
      });
    }
    b.setAttribute('data-h', handle);
    if(cartSet[handle] && !b.classList.contains('done')) b.classList.add('incart');
    b.setAttribute('aria-label', cartSet[handle] ? 'In bag - add one more' : 'Add to bag');
  }

  /* ---- boot ---- */
  function scan(root){ (root||document).querySelectorAll('.pcard,.pje-pcard').forEach(inject); wishCount(); }
  function boot(){ scan(); refreshCount(); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', scan);
  if(window.MutationObserver){
    var t;
    new MutationObserver(function(){ clearTimeout(t); t=setTimeout(function(){ scan(); },150); }).observe(document.documentElement,{childList:true,subtree:true});
  }
})();
